var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFax = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "fax_svg__a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#fax_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#09F",
  d: "M3 19a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 0 16V9q0-1.25.875-2.125A2.9 2.9 0 0 1 3 6q.675 0 1.238.275T5.225 7H6V2h10v5h1q1.25 0 2.125.875T20 10v8H5.225q-.425.45-.987.725A2.8 2.8 0 0 1 3 19m0-2a.97.97 0 0 0 .713-.288A.97.97 0 0 0 4 16V9a.97.97 0 0 0-.287-.713A.97.97 0 0 0 3 8a.97.97 0 0 0-.713.287A.97.97 0 0 0 2 9v7q0 .424.287.712Q2.575 17 3 17M8 7h6V4H8zm-2 9h12v-6a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 9H6zm7-4a.97.97 0 0 0 .713-.288A.97.97 0 0 0 14 11a.97.97 0 0 0-.287-.713A.97.97 0 0 0 13 10a.97.97 0 0 0-.712.287A.97.97 0 0 0 12 11q0 .424.288.712A.97.97 0 0 0 13 12m3 0q.424 0 .712-.288A.97.97 0 0 0 17 11a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 10a.97.97 0 0 0-.712.287A.97.97 0 0 0 15 11q0 .424.288.712A.97.97 0 0 0 16 12m-3 3a.97.97 0 0 0 .713-.288A.97.97 0 0 0 14 14a.97.97 0 0 0-.287-.713A.97.97 0 0 0 13 13a.97.97 0 0 0-.712.287A.97.97 0 0 0 12 14q0 .424.288.712A.97.97 0 0 0 13 15m3 0q.424 0 .712-.288A.97.97 0 0 0 17 14a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 13a.97.97 0 0 0-.712.287A.97.97 0 0 0 15 14q0 .424.288.712A.97.97 0 0 0 16 15m-9 0h4v-5H7z"
}))));
export default SvgFax;